import contentApi from './content';
import { createAsyncDataCache } from './async-data-cache.mjs';

const cache = createAsyncDataCache();
export const resetContentData = () => cache.invalidatePrefix('');

export const CONTENT_KINDS = ['series', 'products', 'footer-links', 'team'];

const cacheKey = (kind, scope) => `${kind}:${scope}`;

export const peekContentData = (kind, scope = 'active') => (
  cache.peek(cacheKey(kind, scope))
);

export const loadContentData = (kind, scope = 'active', options = {}) => {
  const key = cacheKey(kind, scope);
  return cache.load(
    key,
    () => contentApi.get(`/admin/content/${kind}/`, {
      params: { scope },
    }).then((response) => response.data),
    options,
  );
};

export const invalidateContentData = (kind) => cache.invalidatePrefix(`${kind}:`);

export const warmContentData = () => Promise.allSettled(
  CONTENT_KINDS.map((kind) => loadContentData(kind)),
);
